export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-6.png?7ed9b7366256e0b7826ab4e1efc5eb06";